import React from 'react'
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/White-logo.png"
const Footer = () => {
  return (
    <div>
      <footer className="footer-section">
        <div className="footer-container">
          <div className="footer-content">
            <div className="grid-2">

              <div className="footer-widget">
                <div className="footer-logo">
                  <img src={Logo} className="img-fluid" alt="logo" />
                </div>
                <div className="footer-text">
                  <p>Indian Institute of Technology Gandhinagar<br />
                    Palaj, Gandhinagar, Gujarat 382 055</p>
                </div>

                <div className="footer-widget-heading">
                  <h3>Follow us on:</h3>
                </div>
                <div className="socialLinks">

                  <ul>
                    <li>
                      <a href="https://www.instagram.com/sports_iitgn/" target={'_blank'} rel="noreferrer"> <i className="fab fa-instagram"></i> </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/IITGnSports/" target={'_blank'} rel="noreferrer"> <i className="fab fa-facebook-f"></i></a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/watch?v=knxCYgPp0n8" target={'_blank'} rel="noreferrer"> <i className="fab fa-youtube"></i> </a>
                    </li>
                  </ul>
                </div>



              </div>


              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Quick links</h3>
                </div>
                <ul>
                  <li><NavLink to="/" onClick={() => window.scrollTo(0, 0)}>Home</NavLink></li>
                  <li><a href="https://iitgn.ac.in/" target={'_blank'} rel="noreferrer">IITGN</a></li>
                  <li><NavLink to="/sports" onClick={() => window.scrollTo(0, 0)}>Sports</NavLink></li>
                  <li><NavLink to="/events" onClick={() => window.scrollTo(0, 0)}>Events</NavLink></li>
                  <li><NavLink to="events/events-sponsors" onClick={() => window.scrollTo(0, 0)}>Events Sponsors</NavLink></li>
                  <li><NavLink to="events/events-calendar" onClick={() => window.scrollTo(0, 0)}>Events Calendar</NavLink></li>

                  <li><NavLink to="/team" onClick={() => window.scrollTo(0, 0)}>Our Team</NavLink></li>
                  <li><a href="https://students.iitgn.ac.in/hallabol-23/" target={'_blank'} rel="noreferrer">Hallabol </a></li>
                  <li><NavLink to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</NavLink></li>
                  <li><NavLink to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</NavLink></li>

                </ul>
              </div>


            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="container">

            <div className="copyright-text">
              <p>Copyright 2023 Sports@IIT Gandhinagar- All Rights Reserved</p>
            </div>

            {/* <div className="grid-2">
              <div className="copyright-text">
                <p>Copyright 2023 Sports@IIT Gandhinagar- All Rights Reserved</p>
              </div>
              <div className="footer-menu">
                <ul>
                  <li><NavLink to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</NavLink></li>
                  <li><NavLink to="/disclaimer" onClick={() => window.scrollTo(0, 0)}>Disclaimer</NavLink></li>
                </ul>
              </div>

            </div> */}
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer